import React, { useCallback, useState } from 'react'
import { SwitchTransition, CSSTransition } from "react-transition-group";



export default function FilterLinks({ filterableCategories, filterBy, currentFilter }) {
    const [open, setOpen] = useState(false)

    const filter = useCallback((name) => {
        setOpen(false)
        filterBy(name)
    }, [filterBy])

    return (
        <div className="project--categories flex with-dot align-center mrr5 gap-5 m-wrap m-align-bottom m-max-50 overflow-hidden">

            <button className={"button menu-link " + (currentFilter === 'all' ? 'active' : ' ')} key='All' onClick={() => setOpen(true)}>
                <SwitchTransition>
                    <CSSTransition classNames='fade' timeout={500} key={currentFilter}>
                        <span className='capitalise'>
                            {currentFilter}
                        </span>
                    </CSSTransition>
                </SwitchTransition>
            </button>

            <div className="all--categories-wrapper" style={{ width: (open ? '100%' : '0%') }}>
                <div className='flex gap-15 m-wrap all--categories' style={{ opacity: (open ? 1 : 0) }}>
                    <SwitchTransition>
                        <CSSTransition
                            key={currentFilter}
                            timeout={500}
                            classNames="fade-delayed"
                        >
                            <>
                                {filterableCategories.filter(({ name }) => name.toLowerCase() !== currentFilter).map(({ name }) => {
                                    return (
                                        <button className={"button menu-link " + (currentFilter === name.toLowerCase() ? 'active' : ' ')} key={name} onClick={() => filter(name)}>
                                            {name}
                                        </button>
                                    )
                                })}
                            </>
                        </CSSTransition>
                    </SwitchTransition>
                </div>
            </div>
            <SwitchTransition >
                <CSSTransition classNames='fade' timeout={450} key={(open ? 'open' : 'closed')}>
                    <>
                        {!open ? <div className='op-50 category--count text-normal'>(+{filterableCategories.length})</div> :
                            <div className={'category--close open'} role='presentation' onClick={() => setOpen(false)} />
                        }
                    </>
                </CSSTransition>
            </SwitchTransition>


        </div >
    )
}